// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3xSNU","filesListContainer":"PosDisputesFiles_filesListContainer__38w82","filesButton":"PosDisputesFiles_filesButton__2771u"};